import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import AccountUserListUI from '../../components/accountUser/AccountUserListUI'
import AccountUserDeleteModalUI from '../../components/accountUser/AccountUserDeleteModalUI'
import AccountUserUpdateModalUI from '../../components/accountUser/AccountUserUpdateModalUI'

const AccountUserListPageUI = ({context, messageList, accountUserList, filteredAccountUserList,
    // filters
    searchFilter, onSearchFilterChange, allRoleList, onRoleFilterChange, roleFilter,
    // form
    successMsg, errorList, setErrorList,
    // modes
    selectedCount, updateMode, deleteMode, submitted,
    // event handlers
    onRowClick, onRefreshClick, onUpdateClick, onDeleteClick,
    // event handlers in modals
    onConfirmInviteClick, onConfirmUpdateClick, onConfirmDeleteClick, onCancelClick,
    // update form
    roleId, roleList, onRoleIdChange
  }) =>
  <PrivatePageSF context={context} className='pg_acc_users' backLink='/settings'
    messageList={messageList} headerMessageKey='c_account_users'
    centered={!accountUserList && !errorList}
  >
    {
      !accountUserList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountUserList && accountUserList.length !== 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings'
          messageList={messageList} titleMessageKey='c_account_users'
        />
        <AccountUserListUI
          context={context}
          accountUserList={filteredAccountUserList}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          onRoleFilterChange={onRoleFilterChange}
          allRoleList={allRoleList}
          roleFilter={roleFilter}
          //
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onRowClick={onRowClick}
        />
      </div>
    }

    <AccountUserUpdateModalUI
      context={context}
      messageList={messageList}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onConfirmUpdateClick={onConfirmUpdateClick}
      submitted={submitted}
      // update form
      roleId={roleId}
      roleList={roleList}
      onRoleIdChange={onRoleIdChange}
    />

    <AccountUserDeleteModalUI
      context={context}
      messageList={messageList}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      deleteMode={deleteMode}
      onCancelClick={onCancelClick}
      onConfirmDeleteClick={onConfirmDeleteClick}
      submitted={submitted}
    />
  </PrivatePageSF>

export default AccountUserListPageUI
